<template lang="html">
    <div>
        <h2 class="text-center py-3 bold">{{info.title}}</h2>

        <div>
            An error occurred when trying to create an Invoice (#{{info.metadata.productId}}-{{info.metadata.eventId}})<br>
            It seems there are some missing or incorrect information coming from {{info.metadata.invoiceSystemName}}. Please check your configurations.
        </div>

        <div class="mt-4">
            <div class="bold">{{info.metadata.productName}}</div>
            <div>VAT: {{info.metadata.invoiceVAT}}</div>
            <div>Family: {{info.metadata.invoiceFamily}}</div>
            <div>CostCenter: {{info.metadata.invoiceCostCenter}}</div>
        </div>

        <div class="mt-5">
            <button class="btn action wide w-100" @click="clickedOk">OK</button>
            <!-- <button class="btn action wide w-100" @click="clickedCancel">Cancel</button> -->
        </div>
    </div>
</template>

<script>
export default {
    props:{
        info: {
            type: Object,
        }
    },
    methods:{
        clickedOk: function () {
            this.$emit('clickedOk')
        },
        clickedCancel: function () {
            this.$emit('clickedCancel')
        },
    }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// invoiceMissingConf.vue?4cf23e13